import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class ComorbiditiesAndAllergiesChangedJournalEvent extends JournalEvent {
  static type = "comorbidities-and-allergies-changed-journal-event";

  @attr({
    defaultValue() {
      return [];
    }
  })
  declare comorbidities: string[];

  @attr({
    defaultValue() {
      return [];
    }
  })
  declare ignoredComorbidities: string[];

  @attr("string") declare medicatedAllergies: string;

  static validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.comorbidities-and-allergies-changed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "comorbiditiesAndAllergiesChangedJournalEvent"
  })
  declare patient: Patient;

  get hasComorbidities(): boolean {
    return this.comorbidities && this.comorbidities.length > 0;
  }

  get hasMedicatedAllergies(): boolean {
    return Boolean(this.medicatedAllergies);
  }
}

// class used to convert legacy semeia comorbidity codes to valid icd10 codes
export class SemeiaComorbidityCode {
  constructor(public code: string) {}

  get isLegacy(): boolean {
    return Boolean(this.code.match(/^ICD-/));
  }

  get isICD10(): boolean {
    return !this.isLegacy;
  }

  get icd10Code(): string {
    if (this.isICD10) return this.code;

    // remove the starting ICD-
    // replace the "-" with a dot
    return this.code.replace(/^ICD-/, "").replace(/(\d)-(\d)/, "$1.$2");
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "comorbidities-and-allergies-changed-journal-event": ComorbiditiesAndAllergiesChangedJournalEvent;
  }
}
